/**
 * Sends the screening answers to be written as a Bullhorn note [decision 0111].
 *
 * **These had nowhere to go until 2026-09-02.** The questions screen held them in React state and dropped
 * them when the session ended, while its own comment said the answers reach a recruiter as a note. The
 * behaviour was documented and never built, which reads as working to anyone who opens the file.
 *
 * The write is FIRE-AND-REPORT, never a gate: decision 0111 says the kiosk does not judge these answers, so
 * a person must never be stopped because a note failed to save. A failure is returned as a value, never
 * thrown; the caller logs it as the operator signal and carries on.
 */

import { kioskFetch } from './kioskFetch';
/** `status` is present when the api answered and refused; absent when it never answered. */
export type ScreeningOutcome =
  { readonly kind: 'recorded' } | { readonly kind: 'unreachable'; readonly status?: number };

export interface ScreeningAnswer {
  readonly question: string;
  readonly answer: string;
}

const REQUEST_TIMEOUT_MS = 10_000;

function apiBaseUrl(): string {
  return import.meta.env.VITE_API_BASE_URL ?? '';
}

export async function recordScreening(
  candidateId: number,
  answers: readonly ScreeningAnswer[],
  jobTitle?: string,
): Promise<ScreeningOutcome> {
  try {
    const response = await kioskFetch(`${apiBaseUrl()}/screening`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        candidateId,
        answers,
        ...(jobTitle === undefined || jobTitle === '' ? {} : { jobTitle }),
      }),
      signal: AbortSignal.timeout(REQUEST_TIMEOUT_MS),
    });
    return response.ok ? { kind: 'recorded' } : { kind: 'unreachable', status: response.status };
  } catch {
    return { kind: 'unreachable' };
  }
}
